<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card elevation="0" min-height="300px">
        <v-form v-model="valid" ref="paymentForm">
          <v-card-title>
            Payment Process &nbsp;
            <v-chip color="primary">{{itemId}}</v-chip>
            <span class="red--text ml-4">Invoice No ({{payment.code}})</span>
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" md="7">
                <v-row no-gutters>
                  <v-col cols="12" md="3">
                    <v-menu
                      v-model="assignDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="payment.assignDate"
                          label="Deliver Date *"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          required
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="assignDate"
                        @input="assignDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" md="3">
                    <v-text-field
                      prepend-icon="attach_money"
                      label="Restaurant Paid"
                      disabled
                      v-model.number="payment.osPaid"
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      prepend-icon="attach_money"
                      label="Delivery/Amount"
                      v-model.number="payment.amount"
                      disabled
                      dense
                    />
                  </v-col>
                   <v-col cols="12" md="3">
                    <v-text-field
                      prepend-icon="attach_money"
                      label="Extra Weight"
                      v-model.number="payment.extraWeight"
                      disabled
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      prepend-icon="attach_money"
                      label="Item Value"
                      v-model.number="payment.itemValue"
                      placeholder="Placeholder"
                      disabled
                      dense
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Customer Payment"
                      v-model.number="payment.payment"
                      type="number"
                      readonly
                      prepend-icon="payment"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Discount"
                      v-model.number="payment.discount"
                      type="number"
                      disabled
                      prepend-icon="attach_money"
                    />
                  </v-col>
                  <v-col cols="12" md="3" >
                    <v-text-field
                      label="Customer Pre Paid"
                      v-model.number="payment.custPaidCollected"
                      type="number"
                      disabled
                      prepend-icon="attach_money"
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" md="4">
                    <v-text-field
                      label="Customer Paid *"
                      v-model.number="payment.customerPaid"
                      type="number"
                      prepend-icon="payment"
                      :rules="[checkValue]"
                      readonly
                    />
                    <v-select
                      v-model="payment.itemStatus"
                      label="Status"
                      autocomplete="off"
                      prepend-icon="local_taxi"
                      :items="listStatus"
                    />
                    
                    <v-chip color="green white--text" v-if="status=='COMPLETED'">{{status}}</v-chip>
                    <v-chip v-else>{{status}}</v-chip>
                    <v-btn
                      icon
                      text
                      color="primary"
                      outlined
                      class="ml-2 mt-1"
                      @click="clickPhoto()"
                    >
                      <v-icon>camera_enhance</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="4" offset-md="1">
                    <v-textarea
                      name="remark"
                      rows="3"
                      v-model="payment.remark"
                      label="Remark"
                      prepend-icon="description"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <!-- <v-col cols="12" md="4">
                <v-alert border="left" colored-border color="black" elevation="1">
                  <ul>
                    <li>Date : {{payment.date | formatDateTime($moment)}}</li>
                    <li>ModifiedDate : {{payment.modifiedDate | formatDateTime($moment)}}</li>
                  </ul>
                </v-alert>
              </v-col> -->
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" v-if="payment.transactionId == 0" @click="beforeSavePayment">
              <v-icon>save</v-icon>Save
            </v-btn>
            <v-btn color="primary" v-else @click="beforeUpdatePayment">
              <v-icon>edit</v-icon>Update
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn depressed fab small color="primary" outlined>
              <v-icon>help</v-icon>
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
    <v-col>
      <v-dialog
        v-model="dialogPayment"
        persistent
        max-width="400"
        transition="dialog-bottom-transition"
      >
        <paymentDialog
          @closeDialog="dialogPayment = false"
          :transactionId = "transactionId"
        />
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { isNumber } from "util";
import { allowedDate } from "../utils";
import paymentDialog from "@/components/PaymentPhotoDialog.vue";
export default {
  mounted: function () {
    this.loadPayment();
  },
  data: () => {
    return {
      valid: false,
      assignDateMenu: false,
      paymentRule: [
        (v) => v > -1 || "Payment is less than zero",
        (v) => isNumber(v) || "Payment is required",
      ],
      dialogPayment:false,
      transactionId:0
    };
  },
  props: {
    payment: {
      transactionId: Number,
      osId: Number,
      itemId: Number,
      itemValue: Number,
      amount: Number,
      payment: Number,
      customerPaid: Number,
      balance: Number,
      assignDate: {
        type: String,
        default: "",
      }, // DD-MM-YYYY
      date: {
        type: String,
        default: "",
      },
      modifiedDate: {
        type: String,
        default: "",
      },
      remark: {
        type: String,
        default: "",
      },
    },
    itemId: Number,
    status: String,
    loadPayment: Function,
    updatePayment: Function,
  },
  methods: {
    clickPhoto:function(){
      this.dialogPayment = true;
    },
    beforeSavePayment: function () {},
    beforeUpdatePayment: function () {
      this.$refs.paymentForm.validate();
      if (this.valid) {
        this.updatePayment();
      }
    },
    checkValue: function (v) {
      let result = v > -1 || "Paid less than zero";
      if (result == true) {
        result = isNumber(v) || "Paid is require";

        if (result == true) {
          if (v != 0) {
            result =
              v == this.payment.payment ||
              "Customer Paid should be equal with Customer Payment Or Zero";
          }

          return result;
        } else {
          return true;
        }
      }
      return result;
    },
    allowedDate: allowedDate,
  },
  computed: {
    roleDelivery: function () {
      return this.$store.state.userAccount.role == "DELIVERY";
    },
    assignDate: {
      set(value) {
        this.payment.assignDate = this.$moment(
          this.$moment(value, "YYYY-MM-DD")
        ).format("DD-MM-YYYY");
      },
      get() {
        if (this.payment != null && this.payment.assignDate == "") {
          return this.payment.assignDate;
        }
        return this.$moment(
          this.$moment(this.payment.assignDate, "DD-MM-YYYY")
        ).format("YYYY-MM-DD");
      },
    },
    // total: function() {
    //   return this.payment.itemValue + this.payment.amount;
    // },
    listStatus: function () {
      if (this.roleDelivery) {
        return ["ASSIGNED","ACCEPTED","ORDERED","PICKUP","DELIVERED", "ERROR","RETURN"];
      }
      return ["COLLECTED","ASSIGNED","ACCEPTED","ORDERED","PICKUP","DELIVERED", "ERROR", "RETURN", "COMPLETED"];
    },
  },
  watch: {
    "payment.itemStatus": function (value) {
      if (value == "COMPLETED" || value == "DELIVERED") {
        this.payment.customerPaid = this.payment.payment;
        
      } else {
        this.payment.customerPaid = 0;
      }
    },
    payment:function(){
      this.transactionId = this.payment.transactionId;
    }
  },
   components: {paymentDialog},
};
</script>
<style scoped>
.login-full {
  height: 81vh;
}
</style>